'use client';

import { ChevronIcon } from '@insta-club/components';
import { cn } from '@insta-club/utilities';
import React, { useEffect, useRef, useState } from 'react';

export default function Expandable({
    children,
    maxHeight = 200,
    collapsedAdornment = 'جزئیات بیشتر',
    expandedAdornment = 'بستن'
}: {
    children: React.ReactNode;
    maxHeight?: number;
    collapsedAdornment?: string;
    expandedAdornment?: string;
}) {
    const [expanded, setExpanded] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        if (contentRef.current) {
            setIsOverflowing(contentRef.current.scrollHeight > maxHeight);
        }
    }, [children, maxHeight]);

    return (
        <div className='w-full'>
            <div className='relative'>
                <div
                    ref={contentRef}
                    className='overflow-hidden transition-all duration-300'
                    style={{ maxHeight: expanded ? '1000px' : `${maxHeight}px` }}
                >
                    {children}
                </div>

                {!expanded && isOverflowing && (
                    <div
                        className='pointer-events-none absolute right-0 bottom-0 left-0 h-16'
                        style={{
                            background: 'linear-gradient(to top, rgba(255,255,255,1), rgba(255,255,255,0))'
                        }}
                    />
                )}
            </div>

            {isOverflowing && (
                <button
                    type='button'
                    onClick={() => setExpanded(!expanded)}
                    className='text-primary-500 flex items-center text-sm font-medium'
                >
                    {expanded ? expandedAdornment : collapsedAdornment}
                    <ChevronIcon
                        className={cn('text-primary-500 mr-2 h-3.5 w-3.5', {
                            'rotate-90': expanded
                        })}
                    />
                </button>
            )}
        </div>
    );
}

